// When adding a new country-specific "*Sent" delivery event, make sure to also include it in invoiceSentStatusEvents,
// so it is correctly recognized as a sent status in the UI and status logic.
export enum InvoiceEventType {
  DeliveryBaswareEinvoiceFailureEmail = 'delivery.basware.einvoice.failure.email',
  DeliveryBaswareEinvoiceNotification = 'delivery.basware.einvoice.notification',
  DeliveryBaswareEinvoiceSent = 'delivery.basware.einvoice.sent',
  DeliveryBaswarePaperNotification = 'delivery.basware.paper.notification',
  DeliveryBaswarePaperSent = 'delivery.basware.paper.sent',
  DeliveryCreditnoteEmailFailureEmail = 'delivery.creditnote.email.failure.email',
  DeliveryCreditnoteEmailSent = 'delivery.creditnote.email.sent',
  DeliveryEmailCaptchaFailed = 'delivery.email.captcha_failed',
  DeliveryEmailComplained = 'delivery.email.complained',
  DeliveryEmailDelivered = 'delivery.email.delivered',
  DeliveryEmailDropped = 'delivery.email.dropped',
  DeliveryEmailEinvoiceFailedSubject = 'delivery.email.einvoice.failed.subject',
  DeliveryEmailEmailFailedSubject = 'delivery.email.email.failed.subject',
  DeliveryEmailFailed = 'delivery.email.failed',
  DeliveryEmailPaperFailedSubject = 'delivery.email.paper.failed.subject',
  DeliveryEmailSent = 'delivery.email.sent',
  DeliveryInhouseEinvoiceSent = 'delivery.inhouse.einvoice.sent',
  DeliveryManualSent = 'delivery.manual.sent',
  DeliveryManualUnsent = 'delivery.manual.unsent',
  DeliveryPublicDeBaswareEinvoiceNotification = 'delivery.public.de.basware.einvoice.notification',
  DeliveryPublicDeBaswareEinvoiceSent = 'delivery.public.de.basware.einvoice.sent',
  DeliveryPublicFrBaswareEinvoiceNotification = 'delivery.public.fr.basware.einvoice.notification',
  DeliveryPublicFrBaswareEinvoiceSent = 'delivery.public.fr.basware.einvoice.sent',
  DeliveryRecipientPortalOpened = 'delivery.recipient-portal.opened',
  DeliveryReminderEmailComplained = 'delivery.reminder.email.complained',
  DeliveryReminderEmailDelivered = 'delivery.reminder.email.delivered',
  DeliveryReminderEmailDropped = 'delivery.reminder.email.dropped',
  DeliveryReminderEmailFailed = 'delivery.reminder.email.failed',
  DeliveryReminderEmailNotsent = 'delivery.reminder.email.notsent',
  DocumentCreated = 'document.created',
  DocumentCreditNoteCreated = 'document.creditnote.created',
  DocumentDeleted = 'document.deleted',
  DocumentIntegrationCpaToolsCreateRequestRejected = 'document.integration.cpa-tools.create.request.rejected',
  DocumentIntegrationCpaToolsCreateRequestSuccess = 'document.integration.cpa-tools.create.request.success',
  DocumentPdfDownloaded = 'document.pdf.downloaded',
  DocumentReminderEmailSent = 'document.reminder.email.sent',
  DocumentReminderPostNotsent = 'document.reminder.post.notsent',
  DocumentReminderPostSent = 'document.reminder.post.sent',
  FileZugferdGenerated = 'document.generation.zugferd.generated',
}
